var _mask, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 130,
    viewBox: "0 0 75 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1_1669",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235 470C364.787 470 470 364.787 470 235C470 105.213 364.787 0 235 0C105.213 0 0 105.213 0 235C0 364.787 105.213 470 235 470ZM235 386C318.395 386 386 318.395 386 235C386 151.605 318.395 84 235 84C151.605 84 84 151.605 84 235C84 318.395 151.605 386 235 386Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M469 235C469 364.235 364.235 469 235 469V471C365.339 471 471 365.339 471 235H469ZM235 1C364.235 1 469 105.765 469 235H471C471 104.661 365.339 -1 235 -1V1ZM1 235C1 105.765 105.765 1 235 1V-1C104.661 -1 -1 104.661 -1 235H1ZM235 469C105.765 469 1 364.235 1 235H-1C-1 365.339 104.661 471 235 471V469ZM385 235C385 317.843 317.843 385 235 385V387C318.947 387 387 318.947 387 235H385ZM235 85C317.843 85 385 152.157 385 235H387C387 151.053 318.947 83 235 83V85ZM85 235C85 152.157 152.157 85 235 85V83C151.053 83 83 151.053 83 235H85ZM235 385C152.157 385 85 317.843 85 235H83C83 318.947 151.053 387 235 387V385Z",
    fill: "white",
    mask: "url(#path-1-inside-1_1_1669)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.48903a48b980ceef58a628cb8bd24145.svg";
export { ForwardRef as ReactComponent };